<template>
	<div class="text-left" style="color: var(--body-color) !important; font-size: var(--body-size) !important">
		<div class="row-format gap-3">
			<div>
				<div v-html="item.description"></div>
				<div class="font-14" v-if="tokens.get('Item.DueDate')">{{ tokens.get('Item.DueDate') }}</div>
			</div>
      <div @click.stop class="pl-2">
        <v-select
            v-if="item.setQuantity"
            :items="quantityRange"
            v-model="item.quantity"
            outlined
            dense
            :disabled="quantityDisabled"
            class="select"
        ></v-select>
      </div>
      <div class="ml-auto text-right column-format item-price">
				<span style="font-weight: 600">{{ tokens.get('Item.Total') }}</span>
				<span v-if="item.taxable && item.quantity && item.rate" class="font-14">+{{ tokens.get('Item.TaxRate') }} {{ tokens.get('Item.TaxLabel') || $t('invoice.details.tax') }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import marked from 'marked';

	export default {
		name: 'ServiceItemRenderer',

    props: ['item', 'tokens', 'servicePackage', 'agreement', 'services'],

    components: {},

		data: function() {
			return {};
		},

		mounted() {
			this.initialize();
		},

		beforeDestroy() {},

		methods: {
			initialize: function () {
				this.convertMarkdown();
			},

			convertMarkdown: function () {
				if (this.item && this.item.format === 'Markdown' && this.item.description) {
					this.item.description = this.formatMarkdown(this.item.description);
					this.item.format = 'HTML';
				}
			},

			formatMarkdown: function (description) {
				if (description) {
					let m = marked(description, { breaks: true });
					m = m.replaceAll('<a href', '<a target="_blank" href');
					return m;
				} else {
					return null;
				}
			},
		},

		computed: {
			quantityRange() {
				const rangeArray = [];
				for (let i = this.item.quantityMin; i <= this.item.quantityMax; i++) {
					rangeArray.push(i);
				}
				return rangeArray;
			},

			quantityDisabled: function () {
				return (
					(!this.servicePackage.selected && !this.isSinglePackageAndRequired) ||
          (this.item.optional && !this.item.selected) ||
					this.agreement.fullyExecuted ||
					(this.signer && this.signer.locked) ||
					this.mainButtonDisabled
				);
			},

			mainButtonDisabled: function () {
				if (this.editMode) {
					return false;
				}
				return (
					this.agreement.fullyExecuted ||
					(this.signer && this.signer.locked) ||
					(!this.clientMode && this.agreement.clientSigned)
				);
			},

			isSinglePackageAndRequired: function () {
				return this.services.packages.length === 1 && this.services.selectionRequired;
			},
		},
	};
</script>

<style scoped lang="scss">
.select {
  max-width: 75px;
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.item-price {
  align-items: flex-end;
  white-space: nowrap;
}
</style>
